module.exports = __webpack_public_path__ + "img/room_alarm_video_trigger.58e111d2.jpg";